import template from './home.tpl.html';

class HomeLandingController {

  // Ensure all dependencies are correctly injected for minification
  static $inject = [];

  /** @ngInject */
  constructor() {
  }
}

class HomeLandingComponent {
  constructor() {
    this.selector = 'home';
    this.template = template;
    this.controller = HomeLandingController;
  }
}

export default angular
.module("home.view", [])
.component("home", new HomeLandingComponent())
.name;
